<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-title">Crear nuevo documento</h2>

  <div mat-dialog-content>
    <form [formGroup]="form" class="form-content">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="document_type_id">
          @for (t of data.types; track t.id) {
            <mat-option [value]="t.id">{{ t.name }}</mat-option>
          }
        </mat-select>
        @if (form.get('document_type_id')?.hasError('required')) {
          <mat-error>El tipo es obligatorio</mat-error>
        }
      </mat-form-field>

      @if (selectedType?.related_type && selectedType?.related_type !== DocumentRelatedType.User) {
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ relatedTypeLabel }}</mat-label>
          <mat-select formControlName="related_id">
            @for (relatedEntity of relatedEntities; track relatedEntity.trackBy) {
              <mat-option [value]="relatedEntity.id">
                @if (selectedType?.related_type === DocumentRelatedType.WorkingContractVariableCondition) {
                  {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                  @if (relatedEntity.end_date) {
                    - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                  }
                } @else if (selectedType?.related_type === DocumentRelatedType.HealthInsuranceContract) {
                  {{ relatedEntity.contract_identifier }} : {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                  @if (relatedEntity.end_date) {
                    - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                  }
                } @else if (selectedType?.related_type === DocumentRelatedType.HealthInsuranceContractCard) {
                  {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                  @if (relatedEntity.end_date) {
                    - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                  }
                } @else if (selectedType?.related_type === DocumentRelatedType.WorkingContract) {
                  {{ relatedEntity.name }}
                } @else if (selectedType?.related_type === DocumentRelatedType.AbsenceRequest) {
                  {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                  @if (relatedEntity.end_date) {
                    - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                  }
                } @else {
                  {{ relatedEntity.id }}
                }
              </mat-option>
            }
          </mat-select>

          @if (form.get('related_id')?.hasError('required')) {
            <mat-error>Debe seleccionar un {{ relatedTypeLabel.toLowerCase() }}</mat-error>
          }
        </mat-form-field>
      }

      <div class="date-fields-row">
        <div class="date-field">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Fecha inicio</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="start_date" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>

            <mat-datepicker #startPicker></mat-datepicker>

            @if (form.get('start_date')?.hasError('required')) {
              <mat-error>La fecha de inicio es obligatoria</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="date-field">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Fecha fin</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="end_date" />

            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>

            <mat-datepicker #endPicker></mat-datepicker>

            @if (form.get('end_date')?.hasError('invalidDate')) {
              <mat-error>La fecha no es válida</mat-error>
            }
            @if (form.get('end_date')?.hasError('dateAfterStart')) {
              <mat-error>La fecha de fin debe ser posterior a la fecha de inicio</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Comentario</mat-label>
        <textarea matInput formControlName="comment" rows="3" maxlength="255"></textarea>
        <mat-hint>{{ form.get('comment')?.value?.length || 0 }}/255</mat-hint>
        @if (form.get('comment')?.hasError('maxlength')) {
          <mat-error>El comentario no puede exceder 255 caracteres</mat-error>
        }
      </mat-form-field>

      <div class="file-upload">
        <div>
          <input #fileInput type="file" hidden (change)="onFileChange($event)" />
          <button mat-stroked-button color="primary" (click)="fileInput.click()">
            <mat-icon>upload</mat-icon>
            Seleccionar archivo
          </button>

          <div style="margin-top: 8px">
            @if (form.get('file')?.value) {
              <div class="file-info">
                <mat-icon>description</mat-icon>
                <div class="file-details">
                  <div class="file-name">{{ form.get('file')?.value?.name }}</div>
                  <div class="file-size">{{ getFileSize($safeNavigationMigration(form.get('file')?.value)) }}</div>
                </div>
              </div>
            }
          </div>

          @if (form.get('file')?.hasError('required') && (form.get('file')?.touched || form.get('file')?.dirty)) {
            <mat-error>El archivo es obligatorio</mat-error>
          }
          @if (form.get('file')?.hasError('fileSize')) {
            <mat-error> El archivo es demasiado grande. Máximo {{ form.get('file')?.errors?.['fileSize']?.maxSizeInMB }}MB </mat-error>
          }
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-stroked-button (click)="cancel()">Cancelar</button>
    <button mat-flat-button color="accent" (click)="save()" type="submit">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </div>
</div>
